import { __decorate, __metadata } from "tslib";
import { SwapContextToken } from '@1inch-community/sdk/swap';
import '@1inch-community/ui-components/button';
import '@1inch-community/ui-components/icon';
import { SceneController, shiftAnimation } from '@1inch-community/ui-components/scene';
import { consume } from '@lit/context';
import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../fusion-swap-info-auction-time';
import '../fusion-swap-info-main';
import '../fusion-swap-info-slippage';
import { fusionSwapInfoStyle } from './fusion-swap-info.style';
let FusionSwapInfoElement = class FusionSwapInfoElement extends LitElement {
    constructor() {
        super(...arguments);
        this.isOpenFusionInfo = false;
        this.scene = new SceneController('main', {
            main: { lazyRender: true, minHeight: 178 },
            slippage: { minHeight: 79.5 },
            auctionTime: { minHeight: 79.5 },
        }, shiftAnimation());
    }
    static { this.tagName = 'inch-fusion-swap-info'; }
    static { this.styles = [fusionSwapInfoStyle, SceneController.styles()]; }
    render() {
        return this.scene.render({
            main: () => html `
        <inch-fusion-swap-info-main
          .isOpen="${this.isOpenFusionInfo}"
          @openSlippageSettings="${() => this.scene.nextTo('slippage')}"
          @openAuctionTimeSettings="${() => this.scene.nextTo('auctionTime')}"
        ></inch-fusion-swap-info-main>
      `,
            slippage: () => html `
        <inch-fusion-swap-info-slippage
          .settings="${this.context?.getSettingsController('slippage')}"
          @back="${() => {
                this.isOpenFusionInfo = true;
                this.scene.back();
            }}"
        ></inch-fusion-swap-info-slippage>
      `,
            auctionTime: () => html `
        <inch-fusion-swap-info-auction-time
          .settings="${this.context?.getSettingsController('auctionTime')}"
          @back="${() => {
                this.isOpenFusionInfo = true;
                this.scene.back();
            }}"
        ></inch-fusion-swap-info-auction-time>
      `,
        });
    }
};
__decorate([
    consume({ context: SwapContextToken }),
    __metadata("design:type", Object)
], FusionSwapInfoElement.prototype, "context", void 0);
FusionSwapInfoElement = __decorate([
    customElement(FusionSwapInfoElement.tagName)
], FusionSwapInfoElement);
export { FusionSwapInfoElement };
//# sourceMappingURL=fusion-swap-info.element.js.map